/* eslint-disable prettier/prettier */
/* eslint-disable no-console */

import request from '@/utils/request'
import qs from 'qs'
// 工作量统计
export const checkWorkload = (data) => {
  return request({
    url: '/workload/checkWorkload',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}

//工作量统计导出下载
export const workloadExport = (postData) => {
  return request({
    url: '/workload/export',
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;'
    },
    data: qs.stringify(postData),
    responseType: 'blob'
  })
}

//设备类型查看（字典）
export const queryDict = (data) => {
  return request({
    url: '/weight/queryDict',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
// 权重查看
export const pageWeight = (data) => {
  return request({
    url: '/weight/pageWeight',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
//权重修改
export const updateWeight = (data) => {
  return request({
    url: '/weight/updateWeight',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
//权重删除
export const deleteWeight = (data) => {
  return request({
    url: '/weight/deleteWeight',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
//权重添加
export const saveWeight = (data) => {
  return request({
    url: '/weight/saveWeight',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  })
}
